// LIBRARY
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Drawer, Button } from 'antd';
import { IResultsIcon } from 'images';
import Iresults from 'modules/main/iresults';
import { fetchIresult } from 'services/lab_result/result';
import './patientname.css';
import { EditResultContext } from 'context/editResultContext';
const ButtonGroup = Button.Group;


// class PatientName extends React.Component {
function PatientName({patientInfo, sampleSpecimenID, specimenStatus, showIreportButton, getSelectedResults, isApproved, specimenStatusID}){
	
	const [showIresultInfo, setShowIresultInfo] = useState(false);
	const [initialValues, setInitialValues] = useState({});
	const { onChangeResult } =  useContext(EditResultContext);
	
	// useEffect(()=>{
		const fetchInitialData = async() =>{
			const data = await fetchIresult(sampleSpecimenID);

			let initVals = {};

			if(data.length > 0){
				data.map((machineRecord, machineIndex)=>{
					const { contents } = machineRecord;
					contents.map((runDate)=>{
						const { instrumentResultDate } = runDate;
						const machineKey =  Date.parse(instrumentResultDate);
						
						runDate.contents.map((content, contentIndex)=>{
							const keyName = Number(machineKey.toString().concat(contentIndex+1));

							if(content.examItemName !== null && content.instrumentResultUsed === 'TRUE' ){
								initVals[keyName] = true;
							}
						});
					});
				});

				setInitialValues(initVals);
			}

		}

		// fetchData();
	// }, []);
	
	
	const onIresultButtonClick = async () => {
		await fetchInitialData();
		onChangeResult(); 
		setShowIresultInfo(true);
	}
	
	const onCloseIresultsInfoDrawer = () => {
		setShowIresultInfo(false);
	}

	const iReportButton = (()=>{
		if(showIreportButton === false){
			return(<></>);			
		}else{
			return(
				<div style={{ textAlign: 'right', margin: '25px 0 20px 30px', fontSize: '12px' }}>
						<ButtonGroup>
							<Button onClick={onIresultButtonClick} style={{ width: 120 }} disabled={specimenStatusID === 5}>
								<img src={IResultsIcon} className="print-logo" alt="iResults Icon" />
									<span style={{ paddingLeft: '7px' }}>iResults</span>
							</Button>
						</ButtonGroup>
				</div>
			);
		}	
	})();
		
    return (
	    <Row>
		    <Col span={12}>
			    <div style={{ marginBottom: '30px' }}>
				    <h1 style={{ marginBottom: '0', fontWeight: 'bold', letterSpacing: '1px', fontSize: '20px', textTransform:'uppercase' }}>
              {`${patientInfo.lastName}, ${patientInfo.givenName} ${patientInfo.middleName === null ? '' : patientInfo.middleName} ${patientInfo.nameSuffix === null ? '' : patientInfo.nameSuffix}`}
				    </h1>
				    <div style={{ color: '#CCC8C8', letterSpacing: '1px', fontSize: '13px' }}>
             <span>SAMPLE ID: {sampleSpecimenID}</span>
			 				<br />
							<span>REQUEST ID: {patientInfo.requestID}</span>
							<br />
							<span>CURRENT STATUS: {specimenStatus}</span>
							
				    </div>
			    </div>
		    </Col>
				<Col span={12}>
			    {iReportButton}
				</Col>
				{
					showIresultInfo ? 
					(
						<Drawer
							title="Re-run results"
							onClose={onCloseIresultsInfoDrawer}
							width="70%"
							visible={showIresultInfo}
						>
							<Iresults getSelectedResults={getSelectedResults}
								closeDrawer={onCloseIresultsInfoDrawer}
								sampleSpecimenID={sampleSpecimenID}
								isApproved={isApproved}
								initialValues={ initialValues }
							/>
						</Drawer>
					)
					:
					null
				}
	    </Row>
    );
}

PatientName.propTypes = {
	patientInfo: PropTypes.shape({
		lastName: PropTypes.string,
		givenName: PropTypes.string,
		patientID: PropTypes.string,
	}).isRequired,
	sampleSpecimenID: PropTypes.string.isRequired,
	specimenStatus: PropTypes.string.isRequired,
	showIreportButton: PropTypes.bool,
	getSelectedResults: PropTypes.func,
	isApproved: PropTypes.bool.isRequired,
};

PatientName.defaultProps = {
	showIreportButton: true,
};

export default PatientName;
